// extracted by mini-css-extract-plugin
module.exports = {"cpDetailAddressClass":"DetailsPage_cpDetailAddressClass__3sdbd","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__3gIW7"};